import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/imgs/left.png';
import _imports_1 from '@/assets/imgs/right.png';
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "module-name"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "left-img"
}, null, -1);

const _hoisted_4 = {
  class: "name"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "right-img"
}, null, -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "丰富的产品库，产品通道实时更新")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString($props.name), 1), _hoisted_5]), _hoisted_6]);
}